import './../../css/mk-brand.css';
import {useEffect} from "react";

function AboutUsPanel() {
    useEffect(() => {}, );
    return (
        <div id="about-us-panel" className="p-4">
            <div className="flex text-center justify-center">
            <h1 className="text-4xl font-extrabold">About</h1>
            <h1 className=" text-4xl font-extrabold text-brand">Us</h1>
            </div>
            <div className="container font-bold text-center md:text-justify md:text-2xl mx-auto p-4">
                In a world of cyber foodies governed by the blockchain the ultimate NFT battleground is the metaKitchen. To foster culinary training and exploration the metaKitchen has materialized as a virtual world for cyber food supremacy. Founded by the OG Chefs the metaKitchen was constructed out of the spare bits from thousands of overheated gaming consoles hacked together with cooking gadgets. Mastering the digital world the chefs merged with their terminals into the OG Chef NFT collection.
                Once alive in cyberspace the OG Chefs began work on a great metaKitchen capable of unthinkable culinary creations.
                &nbsp;&nbsp;
                <a className="text-brand cursor-pointer" id="more-or-less" onClick={()=>{
                    const e =  document.getElementById("more-or-less");
                    if (e.innerText === "read more...") {
                       e.innerText = "read less" ;
                       document.getElementById("moreAboutUs").classList.remove("hidden");
                    } else {
                        e.innerText = "read more..." ;
                        document.getElementById("moreAboutUs").classList.toggle("hidden");
                    }

                }}>read more...</a>
                <div id="moreAboutUs" className="hidden">
                    <br/>
                    Bringing the love and camaraderie of food, its craft, and innovation to the blockchain while helping chefs in need along the way.
                    metaKitchen is a blockchain PvP cooking battle game inspired by our favorite culinary game shows.
                    At metaKitchen we want to combine all the best elements of blockchain and bring it to as wide of an audience as possible while raising awareness offchain of the thriving Solana ecosystem.
                    Our team has decades of experience founding, developing and investing in successful businesses, and we are committed in running metaKitchen first and foremost with the best interest of our OG Chefs.
                    We envision our OG mint as a cap raise to fund: the development of our full P2E game, mK Syndicate bank and investments and our ultimate metaChef collection.
                    The Dev team is hard at work executing the roadmap to deliver utility and value to our OG Chefs shortly after mint. Join our Discord to chat with the team and learn more about the project.
                </div>
            </div>
        </div>);
}
export default AboutUsPanel;
